// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7d3b4e5b","198":"629506b5","404":"2fd1372e","526":"fc0004c9"}[chunkId] + ".chunk.js";
};